__turbopack_context__.v({
  "archiveEditionLink": "theme-module__tPq4fa__archiveEditionLink",
  "heroContent": "theme-module__tPq4fa__heroContent",
  "infoPanel": "theme-module__tPq4fa__infoPanel",
  "infoPanelAction": "theme-module__tPq4fa__infoPanelAction",
  "infoPanelBody": "theme-module__tPq4fa__infoPanelBody",
  "infoPanelButton": "theme-module__tPq4fa__infoPanelButton",
  "infoPanelCopy": "theme-module__tPq4fa__infoPanelCopy",
  "infoPanelEyebrow": "theme-module__tPq4fa__infoPanelEyebrow",
  "infoPanelText": "theme-module__tPq4fa__infoPanelText",
  "infoPanelTitle": "theme-module__tPq4fa__infoPanelTitle",
  "navToggleReset": "theme-module__tPq4fa__navToggleReset",
  "pageHero": "theme-module__tPq4fa__pageHero",
  "pageHeroContent": "theme-module__tPq4fa__pageHeroContent",
  "pageHeroOverlay": "theme-module__tPq4fa__pageHeroOverlay",
  "podiumAmount": "theme-module__tPq4fa__podiumAmount",
  "podiumCard": "theme-module__tPq4fa__podiumCard",
  "podiumCardBody": "theme-module__tPq4fa__podiumCardBody",
  "podiumCardFeatured": "theme-module__tPq4fa__podiumCardFeatured",
  "podiumCardGlow": "theme-module__tPq4fa__podiumCardGlow",
  "podiumCardStandard": "theme-module__tPq4fa__podiumCardStandard",
  "podiumEyebrow": "theme-module__tPq4fa__podiumEyebrow",
  "podiumGrid": "theme-module__tPq4fa__podiumGrid",
  "podiumLabel": "theme-module__tPq4fa__podiumLabel",
  "successPanel": "theme-module__tPq4fa__successPanel",
  "successPanelBody": "theme-module__tPq4fa__successPanelBody",
  "successPanelEyebrow": "theme-module__tPq4fa__successPanelEyebrow",
  "successPanelGlow": "theme-module__tPq4fa__successPanelGlow",
  "successPanelMeta": "theme-module__tPq4fa__successPanelMeta",
  "successPanelText": "theme-module__tPq4fa__successPanelText",
  "successPanelTitle": "theme-module__tPq4fa__successPanelTitle",
  "theme": "theme-module__tPq4fa__theme",
});
